import React, { useState, useEffect, useRef } from 'react';
import io from 'socket.io-client';
import './App.css';


 // Adresse de l'API Node.js
function hour(){
var date = new Date();
var heure = date.getHours()
var minute= date.getMinutes()
return heure+':'+minute
}
function App() {
  const ENDPOINT = 'wss://psychedelic-vigorous-antlion.glitch.me'
  const [socket, setSocket] = useState(null);
  const [username, setUsername] = useState('');
  const [room, setRoom] = useState('');
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState([]);
  const messageListRef = useRef(null);
  
  useEffect(() => {
    if (socket)
    socket.on('message', (data) => {
      console.log(`Message reçu de ${data.username}: ${data.message} dans le salon ${data.room}`);
      setMessages((messages) => [...messages, data]);
    });
  }, [socket]);

  useEffect(() => {
    if (messageListRef.current) {
      messageListRef.current.scrollTop = messageListRef.current.scrollHeight;
    }
  }, [messages]);
 
  const handleConnect = () => {
    const newSocket = io(ENDPOINT, { headers: {
      "User-Agent": "Mozilla/5.0 (Windows NT 10.0; Win64; x64)"
    }});
    console.log("connecté")
    newSocket.emit('join', { username, room });
    setSocket(newSocket);
  };

  const handleDisconnect = () => {
    if (socket) {
      socket.disconnect();
      console.log("déconnecté")
      setSocket(null);
    }
  };

  const handleMessageSubmit = (e) => {
    e.preventDefault();
    socket.emit('message', { username: username, message: message, room: room });
    console.log("message envoyé")
    setMessage('');
  };
  var page= 
  <div className="app">
  {socket ? (
    <>
      <div className="room-info">
        <h2>{`Room: ${room}`}</h2>
        <button className='leave' onClick={handleDisconnect}>Leave Room</button>
      </div>
      <div className='zone'>
        <div className='zone2' style={{height:'80%',width:'100%',overflow:'scroll'}}>
            <ul>
            
            
            {messages.map((message, index) => (

              <div className='anime_send' key={index} style={{color:'white',height:'auto',maxWidth:'80vw',display:'inline',flexDirection:'column',margin:'10px'}}><div className='anime_send' key={index} style={{color:'white',height:'auto',fontSize:'20px'}}>{message.username}</div><span style={{float:'left',borderRadius:'15px'}}>{message.message}</span></div>
            ))}
            </ul>
        </div>
      
       <div className='contenaire'>
          <form className='messagerie' onSubmit={handleMessageSubmit} style={{width:'90%',display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center'}}>
            <textarea className='input_message' type="text" value={message} onChange={(e) => setMessage(e.target.value)} ></textarea>
            <button className='envoyer' type="submit"><svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#ffffffff"><path d="M0 0h24v24H0z" fill="none"/><path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4z"/></svg></button>
          </form>
       </div>
       
      </div>
    </>
  ) : (
    <div>
        <h1 style={{color:'whitesmoke'}}>Chat<span style={{color:"#1758ff"}}>Room</span></h1>
        <form className="join-form" onSubmit={handleConnect}>
            <input id='username' type='text' required='required' maxLength={25} className='zone_entrer' placeholder="Username" value={username} onChange={(e) => setUsername(e.target.value)} />
            <input id='romm' type='text'  className='zone_entrer'  pattern="[A-Za-z]{4,10}" maxlength="10" title="4 a 10 lettres pas de chiffre" required='required' placeholder="Room" value={room} onChange={(e) => setRoom(e.target.value)} />
            <input type='submit' className='join' value="Entrer dans la room "/>
        </form>
    </div>
   
  )}
</div>
  return page
}

export default App;
